import { Button } from "@/modules/shadcn/ui/button";
import { SearchIcon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NetworkScanDialog } from "../NetworkScanDialog/NetworkScanDialog";

interface DiscoverCameraApiProps {
  onSelect: (url: string) => void;
}

export const DiscoverCameraApi = ({ onSelect }: DiscoverCameraApiProps) => {
  const { t } = useTranslation("camera");
  const [scanOpen, setScanOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        className="h-11"
        onClick={() => setScanOpen(true)}
      >
        <SearchIcon data-icon="inline-start" />
        {t("discovery.openScan")}
      </Button>

      <NetworkScanDialog
        open={scanOpen}
        onOpenChange={setScanOpen}
        onSelect={onSelect}
      />
    </>
  );
};
